import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {commonsTranslateLoader, rootScopeProvider} from 'ib-web-commons/utils';
import {GiftCardsAppConstant} from '@src/ib-gift-cards-constants';
import { IbPaymentsAppModule } from 'ib-web-payments';
import {DatalayerUtilsProvider, IbCDatalayerUtilsService} from 'ib-web-commons/ib-datalayer';
import {IbCommonGenericInterceptorProvider} from 'ib-web-commons/interceptor';
import {IbCPipeModule} from 'ib-web-commons/pipes';
import {IbCModalModule} from 'ib-web-commons/ib-modal';
import {IbCDirectivesModule} from 'ib-web-commons/directives';
import { IbMenusAppModule } from 'ib-menus';
import { IbGiftCardsPaymentsModule } from './app/features/pages/payments/components/ib-gift-cards-payments/ib-gift-cards-payments.module';
import { NgReactModule } from './app/react/ng-react.module';
import { IbGiftCardsConfirmationModule } from './app/features/pages/confirmation/components/ib-gift-cards-confirmation/ib-gift-cards-confirmation.module';

import { IbGiftCardsBannerPromotionComponent } from '@src/app/features/pages/configuration/components/ib-gift-cards-banner-promotion/ib-gift-cards-banner-promotion.component';
import { AJSGiftCardsDatalayerServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-datalayer-bridge-service';
import { AJSGiftCardsCommonsSessionStorageServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-session-storage-bridge.service';
import { AJSGiftCardsCommonsGenericProxyProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-generic-proxy-bridge.service';
import { AJSGiftCardsCommonsModalServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-modal-service-bridge.service';
import { AJSGiftCardsCommonsNewHttpUtilsErrorServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-new-http-utils-error-bridge.service';
import { AJSGiftCardsCommonsUserUtilsServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-user-utils-service-bridge.service';
import { AJSGiftCardsCommonsUtilServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-commons-util-service-bridge.service';
import { AJSGiftCardsCurrencyServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-currency-service-bridge.service';
import { AJSGiftCardsDatalayerUtilsServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-datalayer-utils-service-bridge.service';
import { AJSGiftCardsDigitalDataServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-digital-data-service-bridge.service';
import { AJSGiftCardsCommonsKeepAliveUtilsServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-keep-alive-utils-bridge.service';
import { AJSGiftCardsIbCNewPaymentAvailiabilityServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-new-payment-availiability-service-bridge.service';
import { AJSGiftCardsIbCPermanentUserServiceProvider } from './app/shared/services/upgrades/ib-gift-cards-permanent-user-service-bridge.service';
import { ibGiftCardsCardSelectedComponent } from './app/features/pages/configuration/components/ib-gift-cards-card-selected/ib-gift-cards-card-selected.component';
import { ibGiftCardsThemeComponent } from './app/features/pages/configuration/components/ib-gift-cards-theme/ib-gift-cards-theme.component';
import { IbGiftCardsThemeItemComponent } from './app/features/pages/configuration/components/ib-gift-cards-theme-item/ib-gift-cards-theme-item.component';
import { IbGiftCardsNewContributionModule } from './app/features/pages/contribution/components/ib-gift-cards-new-contribution/ib-gift-cards-new-contribution.module';
import { IbCGenericModalComponent } from './app/shared/modals/generic-modal/ib-commons-generic-modal.component';
import { IbCGenericErrorModalComponent } from './app/shared/modals/generic-error-modal/ib-commons-generic-error-modal.component';


export function createTranslateLoader (http: HttpClient) {
    return commonsTranslateLoader(http, [
        GiftCardsAppConstant.i18nRoute,
        GiftCardsAppConstant.generalI18nRoute
    ]);
}

const commonsModules = [
    IbCPipeModule,
    IbCModalModule,
    IbCDirectivesModule
];

// Fixes ivy aot compilation: https://github.com/angular/angular/issues/37102
const downgradedGiftCardsComponents = [
    IbGiftCardsBannerPromotionComponent
];

@NgModule({
    imports: [
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'es'
        }),
        ...commonsModules,
        IbPaymentsAppModule,
        IbMenusAppModule,
        IbGiftCardsPaymentsModule,
        IbGiftCardsConfirmationModule,
        ibGiftCardsThemeComponent,
        NgReactModule,
        ibGiftCardsCardSelectedComponent,
        IbGiftCardsThemeItemComponent,
        IbGiftCardsNewContributionModule,
        IbCGenericModalComponent,
        IbCGenericErrorModalComponent
    ],
    providers: [
        rootScopeProvider,
        DatalayerUtilsProvider,
        ...IbCommonGenericInterceptorProvider,
        IbCDatalayerUtilsService,
        AJSGiftCardsDatalayerServiceProvider,
        AJSGiftCardsCommonsSessionStorageServiceProvider,
        AJSGiftCardsCommonsGenericProxyProvider,
        AJSGiftCardsCommonsModalServiceProvider,
        AJSGiftCardsCommonsNewHttpUtilsErrorServiceProvider,
        AJSGiftCardsCommonsUserUtilsServiceProvider,
        AJSGiftCardsCommonsUtilServiceProvider,
        AJSGiftCardsCurrencyServiceProvider,
        AJSGiftCardsDatalayerUtilsServiceProvider,
        AJSGiftCardsDigitalDataServiceProvider,
        AJSGiftCardsCommonsKeepAliveUtilsServiceProvider,
        AJSGiftCardsIbCNewPaymentAvailiabilityServiceProvider,
        AJSGiftCardsIbCPermanentUserServiceProvider
    ],
    declarations:[
        ...downgradedGiftCardsComponents,
        IbGiftCardsBannerPromotionComponent
    ]
})

export class IbGiftCardsAppModule implements DoBootstrap {

    static components = [...downgradedGiftCardsComponents];

    constructor (private upgrade: UpgradeModule) { }

    ngDoBootstrap () {
        this.upgrade.bootstrap( document.documentElement, ['ib-gift-cards-app'], { strictDi: true });
    }

}
